// Client-side route chunks

import load from './loadAsync'

export default {
  'index': load(() => import(/* webpackChunkName: "index" */ '../pages')),
  'notes': load(() => import(/* webpackChunkName: "notes" */ '../pages/notes')),
}
